import { Routes } from '@angular/router';
import { authChildGuard } from '@base-platform/core';
import { APP_DEFAULT_INTERNAL_PATH } from './app-routing.constants';
import { featuresPublicRoutes } from './features/features-public.routes';

export const appRoutes: Routes = [
  ...featuresPublicRoutes,
  {
    path: '',
    canActivateChild: [authChildGuard],
    loadChildren: () => import('./features/features-private.routes').then(m => m.featuresPrivateRoutes),
  },
  { path: '**', redirectTo: APP_DEFAULT_INTERNAL_PATH },
];
